import React from 'react'
import { Icon } from '@iconify/react'

function ClassroomCommunity() {
  return (
    <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">
      <div className="p-8 sm:p-12 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gray-100 text-gray-400 mb-4">
          <Icon icon="fluent:chat-24-regular" width="32" height="32" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Community</h3>
        <p className="text-gray-500 text-sm max-w-md mx-auto mb-0">
          Community uses the same component as the user side. Content will appear here when available.
        </p>
      </div>
    </div>
  )
}

export default ClassroomCommunity